import type { SupervisorFinding } from '@avisoma/shared';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Button } from '../../catalyst/button';
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu } from '../../catalyst/dropdown';
import {
  COMPACT_BUTTON_CLASS,
  DISMISS_REASONS,
  DISMISS_REASON_LABEL,
  findingButtonsFor,
  type FindingButton,
} from '../../lib/findingActions';
import type { SupervisorFindingMutations } from './useSupervisorFindingMutations';

type Props = { finding: SupervisorFinding; actions: SupervisorFindingMutations };

/** One Corrections row's Actions cell. Every button is disabled while any action of the tab runs. */
export function FindingActions({ finding, actions }: Props) {
  const buttons = findingButtonsFor(finding);
  if (buttons.length === 0) return null;
  const { busy } = actions;

  const renderButton = (b: FindingButton) => {
    switch (b) {
      case 'apply':
        return (
          <Button key={b} color="green" buttonClassName={COMPACT_BUTTON_CLASS} disabled={busy} onClick={() => actions.apply(finding.id)}>
            Apply
          </Button>
        );
      case 'revert':
        return (
          <Button key={b} outline buttonClassName={COMPACT_BUTTON_CLASS} disabled={busy} onClick={() => actions.revert(finding.id)}>
            Revert
          </Button>
        );
      case 'restore':
        return (
          <Button key={b} outline buttonClassName={COMPACT_BUTTON_CLASS} disabled={busy} onClick={() => actions.restore(finding.id)}>
            Restore
          </Button>
        );
      case 'dismiss':
      case 'acknowledge':
        return (
          <Dropdown key={b}>
            <DropdownButton as={Button} outline buttonClassName={COMPACT_BUTTON_CLASS} disabled={busy}>
              {b === 'dismiss' ? 'Dismiss' : 'Acknowledge'}
              <ChevronDownIcon />
            </DropdownButton>
            <DropdownMenu anchor="bottom end">
              {DISMISS_REASONS.map((reason) => (
                <DropdownItem key={reason} onClick={() => actions.dismiss(finding.id, reason)}>
                  <DropdownLabel>{DISMISS_REASON_LABEL[reason]}</DropdownLabel>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        );
    }
  };

  return <div className="flex flex-wrap items-center gap-1">{buttons.map(renderButton)}</div>;
}
